<template>
  <body v-show="startRender">
    <div class="modal winner">
      <div class="modal-in">
        <a href="#" class="close"></a>
        <h2>
          <span>{{ plusAmount }} FUS </span>당첨!!
        </h2>
        <h3>
          <div class="item">
            <img v-for="(num, index) in gameResult" :key="index" :src="'images/img/item' + num + '.png'" alt="" />
          </div>
        </h3>
        <div class="cont">
          <p>축하합니다. {{ plusAmount }} FUS에 당첨되셨습니다.</p>
          <p>당첨된 FUS는 바로 보유FUS에 지급되어 합산됩니다.</p>
        </div>
      </div>
    </div>
    <div class="help">
      <div class="open">
        <p style="white-space: inherit">사용자가 참여하여 해당 아이템을 채굴하는 게임입니다.</p>
        <p>복권 발권시 채굴권이 소모됩니다.</p>
        <p>복권 발권 후 사용하지 않은 복권도 사용으로 처리됩니다.</p>
        <p>복권에 당첨된 결과는 바로 지급됩니다.</p>
        <p>비정상적 방법을 이용한 경우 획득한 FUS는 모두 회수됩니다.</p>
      </div>
      <a href="#" class="toggle"></a>
    </div>
    <a href="javascript:window.history.back();" class="close-this"><img src="images/btn/close-big-w.svg" alt="" /></a>
    <div class="wrap">
      <div class="title jjan">
        <img src="images/img/title.svg" alt="" />
        <template v-if="check == true">
          <h4 class="remain"><span>채굴권 획득 가능!</span> <a class="get" @click="startNativeAd()">채굴권 받기</a></h4>
        </template>
        <template v-else>
          <h4 class="remain">
            <span>{{ timeText }}</span
            >후에 채굴권 획득 가능
          </h4>
        </template>
        <!--<h4 class="remain"><span>06:58:32</span>후에 채굴권 획득 가능</h4>-->
        <!-- <h4 class="remain"><span>채굴권 획득 가능!</span> <a href="#" class="get">채굴권 받기</a></h4> -->
      </div>

      <div class="scratch notyet">
        <div class="card">
          <div :class="ticketCnt < 1 && scratchEnded ? 'disable on' : 'disable'">
            <h3>채굴권이 필요합니다.</h3>
            <p>채굴권은 앱내 다양한 활동으로<br />획득 가능합니다.</p>
            <div class="btns">
              <a class="impor" @click="startNativeAd()" v-show="check">채굴권 획득</a>
              <!--a href="#" class="impor">구매하여 참여(-1.0 Ⓕ)</a>-->
            </div>
          </div>
          <img src="images/img/hand.png" alt="" class="hand" />
          <div class="badge fus">
            <h4>10만</h4>
            <h5>FUS</h5>
          </div>
          <div class="fus-total">
            <p>
              보유한&nbsp;FUS <span>{{ accountCoinView }}</span>
            </p>
          </div>
          <div class="ment">
            <p><strong>행운그림 3개가 모두 일치</strong>하면 당첨!</p>
          </div>
          <div class="container" id="js-container">
            <div class="start-ment">
              <p>긁으면 바로 시작!</p>
            </div>
            <div class="ticketing">
              <a href="#"
                ><p>복권 발권하기</p>
                <p class="ext">복권 발권시 채굴권이 사용됩니다.</p></a
              >
            </div>
            <!--
            <div class="scratch-area">
               <canvas class="canvas" id="js-canvas" width="315" height="180"></canvas>
            </div>
            -->
            <!-- origin
               
            -->
            <canvas class="canvas" id="js-canvas" width="315" height="180"></canvas>

            <form class="form" style="visibility: visible">
              <ul class="set">
                <li v-for="(result, index) in gameResult" :key="index">
                  <div class="fus">
                    <img :src="'images/img/item' + result + '.png'" alt="" />
                  </div>
                </li>
              </ul>
            </form>
          </div>
          <div class="text">
            <!-- <h2><span>보유 FUS</span>24,502</h2> -->
            <div class="ticket">
              <div class="select-mine">
                <p class="mine-ticket">
                  보유 채굴권: <span>{{ ticketCntView }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="score">
        <table cellpadding="0">
          <tbody>
            <tr v-for="(i, row_index) in winInfoList.length / 3" :key="row_index">
              <td v-for="(p, index) in winInfoList.length / 3" :key="index">
                <div class="items">
                  <div class="item">
                    <img :src="`images/basic/img/slot-${winInfoIcons[p - 1 + (i - 1) * 3]}.png`" alt="" />
                    <img :src="`images/basic/img/slot-${winInfoIcons[p - 1 + (i - 1) * 3]}.png`" alt="" />
                    <img :src="`images/basic/img/slot-${winInfoIcons[p - 1 + (i - 1) * 3]}.png`" alt="" />
                  </div>
                  <p>+{{ winInfoList[p - 1 + (i - 1) * 3].fusAmount }}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="log">
        <ul class="list">
          <li v-for="user in userList" :key="user.scratchId" :class="user.joinText.includes('당첨') ? 'winner' : ''">
            <div class="profile" :style="`background-image: url(${user.userInfo.myPhotoUrl}), url(/images/basic/img/default.svg) ;border-radius:50%`"></div>
            <div class="infos">
              <p>{{ user.joinText }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </body>
</template>

<script>
import $ from "jquery";
import Vue from "vue";
import VueHead from "vue-head";
import { timeCheck, create, use, check } from "@/api/mining";
Vue.use(VueHead);
export default {
  head: {
    title: {
      inner: "더해-블록체인 커뮤니티 플랫폼",
    },
    script: [{ src: "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js", integrity: "sha512-bLT0Qm9VnAYZDflyKcBaQ2gg0hSYNQrJ8RilYldYQ1FxQYoCLtUjuuRuZo+fjqhx/qtq/1itJ0C2ejDxltZVFg==", crossorigin: "anonymous" }],
    meta: [{ charset: "UTF-8" }, { name: "viewport", content: '"width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover' }, { name: "apple-mobile-web-app-title", content: "더해" }, { name: "apple-mobile-web-app-capable", content: "yes" }, { name: "msapplication-TileColor", content: "#ffffff" }, { name: "theme-color", content: "#ffffff" }, { name: "msapplication-TileImage", content: "/ms-icon-144x144.png" }, { name: "apple-mobile-web-app-status-bar-style", content: "default" }, { property: 'og:url"', content: "" }, { property: 'og:title"', content: "더해" }, { property: 'og:type"', content: "website" }, { property: 'og:image"', content: "images/favicon/og.png" }, { property: 'og:description"', content: "즐거움과 혜택이 더해지는 커뮤니티 플랫폼" }],
    link: [
      { rel: "stylesheet", type: "text/css", href: "stylesheets/luckycard.css" },
      { rel: "apple-touch-icon", sizes: "57x57", href: "images/favicon/apple-icon-57x57.png" },
      { rel: "apple-touch-icon", sizes: "60x60", href: "images/favicon/apple-icon-60x60.png" },
      { rel: "apple-touch-icon", sizes: "72x72", href: "images/favicon/apple-icon-72x72.png" },
      { rel: "apple-touch-icon", sizes: "76x76", href: "images/favicon/apple-icon-76x76.png" },
      { rel: "apple-touch-icon", sizes: "114x114", href: "images/favicon/apple-icon-114x114.png" },
      { rel: "apple-touch-icon", sizes: "120x120", href: "images/favicon/apple-icon-120x120.png" },
      { rel: "apple-touch-icon", sizes: "144x144", href: "images/favicon/apple-icon-144x144.png" },
      { rel: "apple-touch-icon", sizes: "152x152", href: "images/favicon/apple-icon-152x152.png" },
      { rel: "apple-touch-icon", sizes: "180x180", href: "images/favicon/apple-icon-180x180.png" },
      { rel: "icon", type: "image/png", sizes: "192x192", href: "images/favicon/android-icon-192x192.png" },
      { rel: "icon", type: "image/png", sizes: "32x32", href: "images/favicon/favicon-32x32.png" },
      { rel: "icon", type: "image/png", sizes: "96x96", href: "images/favicon/favicon-96x96.png" },
      { rel: "icon", type: "image/png", sizes: "16x16", href: "images/favicon/favicon-16x16.png" },
    ],
  },
  data() {
    return {
      startRender: false,

      accountCoinView: "",
      ticketCntView: "",
      tempTicketCnt: 0, // 내 티켓 카운트
      gameResult: [], // 주사위 RESULT
      timeText: "", // 채굴권 흭득 가능시간 TEXT
      second: 0, // 채굴권 흭득 가능시간 second
      check: false, // ?TODO
      plusAmount: 0.1,

      // under  참여자 관련정보
      gameResultIcons: ["bonus", "bell", "jwel", "money", "clover", "heart", "grape", "seven", "thehae"],
      winInfoIcons: ["thehae", "seven", "grape", "heart", "clover", "money", "jwel", "bell", "bonus"],
      //gameResultIcons:["thehae","seven","grape","heart","clover","money","jwel","bell","bonus"],
      winInfoList: [],
      userList: [], // 참여자 list
      resultCnt: 0, // 촘 참여자수
      maxSum: 0, // 최고점수

      // scratch value
      scratchStarted: false,
      scratchEnded: true,
    };
  },
  created() {
    // remove common css
    console.log("-*-------");
    if($('link[href*="/stylesheets/reset.css"]')[0])$('link[href*="/stylesheets/reset.css"]')[0].remove();
    if($('link[href*="/stylesheets/style.css"]')[0])$('link[href*="/stylesheets/style.css"]')[0].remove();
    
    this.adTimeCheck();
    this.checkList();
  },
  mounted() {
    window.VueRoot = this;
    $(function () {
      $('a[href="#"]').click(function (e) {
        e.preventDefault();
      });
      $(".help").click(function () {
        $(this).toggleClass("ed");
      });
      $(".modal-call").click(function (e) {
        e.preventDefault();
        $("body").addClass("modal-poped");
        var modalID = $(this).attr("rel");
        $("." + modalID).addClass("active");
      });
      $("a.close").click(function () {
        $(this).parent().parent().removeClass("active");
        $("body").removeClass("modal-poped");
      });
      $(".select li").click(function () {
        $(this).addClass("checked").siblings().removeClass("checked");
      });
      $(".disable .btns a").click(function (e) {
        //$(".disable").removeClass("on");
      });
      $(".ticketing a").click(function (e) {
        window.VueRoot.useTicket(); //티켓 사용
      });
    });
    (function () {
      "use strict";
      var isDrawing, lastPoint;
      var canvas = document.getElementById("js-canvas"),
        canvasWidth = canvas.width,
        canvasHeight = canvas.height,
        ctx = canvas.getContext("2d"),
        image = new Image(),
        brush = new Image();

      // base64 Workaround because Same-Origin-Policy
      image.src = "images/basic/img/watermark-full.svg";
      image.onload = function () {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.beginPath();

        ctx.drawImage(image, 0, 0);

        // Show the form when Image is loaded.
        document.querySelectorAll(".form")[0].style.visibility = "visible";
      };
      brush.src = "images/basic/img/scarchimagetrans.png";

      canvas.addEventListener("mousedown", handleMouseDown, false);
      canvas.addEventListener("touchstart", handleMouseDown, false);
      canvas.addEventListener("mousemove", handleMouseMove, false);
      canvas.addEventListener("touchmove", handleMouseMove, false);
      canvas.addEventListener("mouseup", handleMouseUp, false);
      canvas.addEventListener("touchend", handleMouseUp, false);

      function distanceBetween(point1, point2) {
        return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
      }

      function angleBetween(point1, point2) {
        return Math.atan2(point2.x - point1.x, point2.y - point1.y);
      }

      // Only test every `stride` pixel. `stride`x faster,
      // but might lead to inaccuracy
      function getFilledInPixels(stride) {
        if (!stride || stride < 1) {
          stride = 1;
        }

        var pixels = ctx.getImageData(0, 0, canvasWidth, canvasHeight),
          pdata = pixels.data,
          l = pdata.length,
          total = l / stride,
          count = 0;

        // Iterate over all pixels
        for (var i = (count = 0); i < l; i += stride) {
          if (parseInt(pdata[i]) === 0) {
            count++;
          }
        }

        return Math.round((count / total) * 100);
      }

      function getMouse(e, canvas) {
        var offsetX = 0,
          offsetY = 0,
          mx,
          my;

        if (canvas.offsetParent !== undefined) {
          do {
            offsetX += canvas.offsetLeft;
            offsetY += canvas.offsetTop;
          } while ((canvas = canvas.offsetParent));
        }

        mx = (e.pageX || e.touches[0].clientX) - offsetX;
        my = (e.pageY || e.touches[0].clientY) - offsetY;

        return { x: mx, y: my };
      }

      function handlePercentage(filledInPixels) {
        filledInPixels = filledInPixels || 0;
        // debug percent
        //console.log( filledInPixels + '%' );
        if (filledInPixels > 60) {
          window.$("body").addClass("modal-poped");
          window.$(".modal.winner").addClass("active");
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.beginPath();
          ctx.globalCompositeOperation = "source-over";
          ctx.drawImage(image, 0, 0);

          document.querySelectorAll(".form")[0].style.visibility = "visible";
          //window.VueRoot.$store.commit('udtTicketCnt', window.VueRoot.tempTicketCnt);
          window.VueRoot.scratchStarted = false;
          window.VueRoot.scratchEnded = true;
          window.$(".scratch").addClass("notyet");
          window.VueRoot.checkList();
        }
        $(".start-ment").css("display", "none");
      }

      function handleMouseDown(e) {
        isDrawing = true;
        lastPoint = getMouse(e, canvas);
      }

      function handleMouseMove(e) {
        if (!isDrawing) {
          return;
        }
        if (window.$(".modal.winner").hasClass("active")) return;

        /*
            if(!window.VueRoot.scratchStarted){
              window.VueRoot.useTicket(); //티켓 사용
            }
            */
        window.VueRoot.scratchStarted = true;

        e.preventDefault();

        var currentPoint = getMouse(e, canvas),
          dist = distanceBetween(lastPoint, currentPoint),
          angle = angleBetween(lastPoint, currentPoint),
          x,
          y;

        for (var i = 0; i < dist; i++) {
          x = lastPoint.x + Math.sin(angle) * i - 25;
          y = lastPoint.y + Math.cos(angle) * i - 25;
          ctx.globalCompositeOperation = "destination-out";
          ctx.drawImage(brush, x, y);
        }

        lastPoint = currentPoint;
        handlePercentage(getFilledInPixels(32));
      }

      function handleMouseUp() {
        isDrawing = false;
      }

      function startNativeAd() {
        var varUA = navigator.userAgent.toLowerCase();
        if (varUA.indexOf("android") > -1) {
          //ANDDROID
          window.Android.playRewardAd();
        } else if (varUA.indexOf("iphone") > -1 || varUA.indexOf("ipad") > -1 || varUA.indexOf("ipod") > -1) {
          //IOS
        } else {
          //아이폰, 안드로이드 외
        }
      }
    })();
  },
  computed: {
    accountCoin() {
      var accountCoin = this.$store.state.userInfo.accountCoin == undefined ? 0 : this.$store.state.userInfo.accountCoin;
      return accountCoin;
    },
    ticketCnt() {
      if (this.$store.state.userInfo.ticketCnt == undefined) {
        return 0;
      } else {
        return this.$store.state.userInfo.ticketCnt;
      }
    },
    fusAmount() {
      var fusStr = "0.1";
      if (this.gameResult.length > 0) {
        if (this.gameResult.every((v) => v === this.gameResult[0])) {
          fusStr = "10만";
        }
      }
      return fusStr;
    },
  },
  methods: {
    addScript() {
      let scripts = [];
      for (let i = 0, len = scripts.length; i < len; i++) {
        let script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", scripts[i]);
        script.async = false;
        document.getElementsByTagName("body")[0].appendChild(script);
      }
    },
    startNativeAd() {
      var varUA = navigator.userAgent.toLowerCase();
      if (varUA.indexOf("android") > -1) {
        //ANDDROID
        try {
          window.Android.platInterstitialAd("AD3");
        } catch {
          window.Android.playRewardAd();
        }
      } else if (varUA.indexOf("iphone") > -1 || varUA.indexOf("ipad") > -1 || varUA.indexOf("ipod") > -1) {
        //IOS
        window.webkit.messageHandlers.platInterstitialAd.postMessage("AD3");
      } else {
        //아이폰, 안드로이드 외
      }
    },
    adTimeCheck() {
      timeCheck({
        adType: "AD3",
      }).then(({ data }) => {
        this.check = data.check;
        this.second = data.second;
        if (this.second > 0) {
          this.uiSetTimeText();
        }
      });
    },
    uiSetTimeText() {
      if (this.interval != undefined) clearInterval(this.interval);
      this.interval = setInterval(function () {
        window.VueRoot.second--;
        var sec_num = window.VueRoot.second; // don't forget the second param
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - hours * 3600) / 60);
        var seconds = sec_num - hours * 3600 - minutes * 60;
        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        var timeTextStr = hours + ":" + minutes + ":" + seconds;
        window.VueRoot.timeText = timeTextStr;
        if (sec_num < 0) {
          clearInterval(window.VueRoot.interval);
          window.VueRoot.adTimeCheck();
        }
      }, 1000);
    },
    useTicket() {
      if(!$(".scratch").hasClass("notyet")) return;
      this.gameResult = [];
      $(".scratch").removeClass("notyet");
      use({
        gameType: "scratch",
      }).then(({ data }) => {
        this.scratchEnded = false;
        this.gameResult = data.gameResult;
        this.plusAmount = data.plusAmount;
        this.ticketCntView = data.ticketCntView;
        this.tempTicketCnt = data.ticketCnt;
        //this.accountCoinView = data.accountCoinView;
        window.VueRoot.$store.commit("udtTicketCnt", window.VueRoot.tempTicketCnt);
        
      });
    },
    /**
     * 모바일에서 광고 시청이 완료되었을때 불리는 function
     * do ticket add rest ful apu call
     * native => Vue
     * @adType = "AD1","AD2","AD3" // 해당 값은 일단 유동적으로
     *            각게임마다 정해진 AD<NUM> 사용해볼것
     */
    addTicketCnt(adType) {
      create({
        adType: "AD3",
      }).then(({ data }) => {
        this.$store.commit("udtTicketCnt", data.ticketCnt);
        this.checkList();
      });
    },
    /**
     * 채굴권 갯수 확인 및 참여리스트
     */
    checkList() {
      check({
        gameType: "scratch",
      }).then(({ data }) => {
        this.accountCoin = data.accountCoin;
        this.accountCoinView = data.accountCoinView;
        this.resultCnt = data.resultCnt;
        this.userList = data.resultList;
        this.winInfoList = data.winInfoList;

        this.startRender = true;
        this.ticketCntView = data.ticketCntView;
        this.$store.commit("udtAccountCoin", data.accountCoin);
        this.adTimeCheck();
      });
    },
  },
};
</script>

<style></style>
